<template>
  <div class="container-fluid pt-5 px-0 mt-5 product-search-page">
    <div class="hero-wrapper d-none">
      <div class="gradient-overlay"></div>
    </div>
    <ProductList :initialSearchTerm="searchTerm" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ProductList from '@/components/ProductList.vue';

const route = useRoute();
const searchTerm = computed(() => route.query.search || '');
</script>

<style scoped>
.product-search-page {
  min-height: 100vh;
  background: #000000;
}

.hero-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  height: 600px;
}
.hero-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gradient-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(255, 255, 255, 1));
}
</style>
